import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const data = [
    { day: 'Mon', bpm: 72 },
    { day: 'Tue', bpm: 75 },
    { day: 'Wed', bpm: 71 },
    { day: 'Thu', bpm: 78 },
    { day: 'Fri', bpm: 74 },
    { day: 'Sat', bpm: 82 },
    { day: 'Sun', bpm: 76 },
];

const HealthStats = () => {
    return (
        <div className="health-stats-card p-3 bg-white rounded-lg shadow-sm border border-slate-200 my-2">
            <h4 className="text-sm font-bold text-slate-700 mb-2">Heart Rate (Last 7 Days)</h4>
            <div style={{ width: '100%', height: 150 }}>
                <ResponsiveContainer>
                    <LineChart data={data}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                        <XAxis dataKey="day" style={{ fontSize: '10px' }} tick={{ fill: '#64748b' }} />
                        <YAxis hide domain={['dataMin - 5', 'dataMax + 5']} />
                        <Tooltip
                            contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}
                            labelStyle={{ color: '#64748b', fontSize: '12px' }}
                        />
                        <Line
                            type="monotone"
                            dataKey="bpm"
                            stroke="#0d9488"
                            strokeWidth={3}
                            dot={{ fill: '#0d9488', r: 3 }}
                            activeDot={{ r: 5 }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default HealthStats;
